const lupino = {
  title: 'Lupino',
  cards: [],
};

export default lupino;
